// extracted by mini-css-extract-plugin
export default {"buildingTypeToolbar":"tableView_buildingTypeToolbar__5S0GY"};